export default __webpack_public_path__ + "static/media/Guinea Bissau.c37d5684.png";